import React from "react";
import { useTranslation } from "react-i18next";
import { ZoneCardProps } from "../../types/screensTypes";
import styles from "./MuseumZoneCard.module.css";

const ZoneCard: React.FC<ZoneCardProps> = ({ zone, onClick, onDelete }) => {
    const { url, internalName, position } = zone;
    const { t: rawT } = useTranslation();
    const t = rawT as any;

    return (
        <div className={styles.card} onClick={() => onClick()}>
            {url ? (
                <img src={url} alt={internalName} className={styles.image} />
            ) : (
                <div className={`${styles.image} ${styles.imageEmpty}`} />
            )}

            <div className={styles.content}>
                <h3 className={styles.title}>{internalName || t("unnamed")}</h3>
                <div className={styles.row}>
                    <p className={styles.detail}>
                        <strong>
                            {t("position")}: <span>{position}</span>
                        </strong>
                    </p>
                    <button
                        type="button"
                        className={styles.deleteBtn}
                        onClick={(e: React.MouseEvent<HTMLButtonElement>) => {
                            e.stopPropagation();
                            onDelete();
                        }}
                    >
                        {t("delete")}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ZoneCard;
